module.exports = __webpack_public_path__ + "img/empty_animation.f60a8eda.gif";